// @ts-nocheck
import {Column} from 'react-table'
import {DeletedTransactions} from '../../core/_models'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'
import { DeletedTransactionsCustomHeader } from './DeletedTransactionsCustomHeader'
import DeletedTransactionsAmountInfoCell from './DeletedTransactionsAmountInfoCell'
import { DeletedTransactionsActionsCell } from './DeletedTransactionsActionsCell'
import { checkDisplayValue, formatDate } from 'src/utils'
import TransactionsUserCell from './TransactionsUserCell'
import { constants } from 'src/utils/const'
import { CopyToClipboardIcon } from 'src/app/components/CopyToClipboardIcon';
import React from 'react'


const DeletedTransactionsColumns: ReadonlyArray<Column<DeletedTransactions>> = [
  {
    Header: (props) => (
      <DeletedTransactionsCustomHeader
        tableProps={props}
        title='Sr.No'
        className='text-center min-w-50px'
      />
    ),
    accessor: 'id',
    Cell: ({value}) => value,
  },
  {
    Header: (props) => (
      <DeletedTransactionsCustomHeader tableProps={props} title='Deleted On' className='min-w-125px' />
    ),
    accessor: 'deleted_at',
    Cell: ({value}) => 
          <>
          
        <div className='remarks-cell text-center'>
        {formatDate(value?.replace?.(' ', 'T'), constants.DATE_FORMAT.DD_MM_YYYY_HH_MM_SS)}
        </div>
      
      </>
  },
  {
    Header: (props) => (
      <DeletedTransactionsCustomHeader tableProps={props} title='Amount' className='min-w-125px' />
    ),
    accessor: 'amount',
    Cell: ({value}) => <DeletedTransactionsAmountInfoCell value={value} />,
  },
  {
    Header: (props) => (
      <DeletedTransactionsCustomHeader tableProps={props} title='Sender' className='min-w-125px' />
    ),
    accessor: 'source',
    Cell: ({value, row}) => (
      <TransactionsUserCell
        value={value}
        type='source'
        code={row.original.sender_party_code}
      />
    ),
  },
  {
    Header: (props) => (
      <DeletedTransactionsCustomHeader tableProps={props} title='Receiver' className='min-w-125px' />
    ),
    accessor: 'destination',
    Cell: ({value, row}) => (
      <TransactionsUserCell
        value={value}
        type='destination'
        code={row.original.receiver_party_code}
      />
    ),
  },
  {
    Header: (props) => (
      <DeletedTransactionsCustomHeader tableProps={props} title='Remarks' className='min-w-125px' />
    ),
    accessor: 'remarks',
    Cell: ({value}) => {
      // const [isCopied, setIsCopied] = React.useState(false);
      const [showIcon, setShowIcon] = React.useState(false);

      if (!value) {
        return <div className='remarks-cell text-center'>-</div>;
      }
return (
      <OverlayTrigger
        key='top'
        placement='top'
        overlay={
          <Tooltip id={`tooltip-top`}>
            {value}
          </Tooltip>
        }
      >
        <div 
          className='remarks-cell text-center d-flex align-items-center justify-content-center'
          onMouseEnter={() => setShowIcon(true)}
          onMouseLeave={() => setShowIcon(false)}
          style={{ cursor: 'pointer' }}
        >
          <span>
            {checkDisplayValue(value) && checkDisplayValue(value).length > 20
              ? checkDisplayValue(value).substring(0, 10) + '...'
              : checkDisplayValue(value)}{' '}
          </span>
          {showIcon && <CopyToClipboardIcon value={value} />}
        </div>
      </OverlayTrigger>
    );

    },
  },

  {
    Header: (props) => (
      <DeletedTransactionsCustomHeader tableProps={props} title='CreatedBy' className='min-w-125px' />
    ),
    accessor: 'created_by_name',
    Cell: ({value}) => value,
  },
]

export {DeletedTransactionsColumns}
